import { NON_BREAKING_SPACE } from '@constants/common.constants';

/**
 * Formats an array of names for display by replacing spaces with non-breaking
 * spaces (so names do not wrap mid-word) and joining with comma.
 *
 * @param names - Array of name strings (e.g. primary tax filer names)
 * @param fallback - Optional value when names is empty or undefined
 * @returns Comma-separated names with non-breaking spaces inside each name, or fallback when empty
 *
 * @example
 * / With fallback (default '-' when omitted)
 * formatNamesReplaceSpace(['John Smith', 'Jane Doe']);
 * => 'John Smith, Jane Doe'
 *
 * formatNamesReplaceSpace(null);
 * / => '-'
 *
 * formatNamesReplaceSpace([]);
 * / => '-'
 *
 * @example
 * / With custom fallback
 * formatNamesReplaceSpace(undefined, 'N/A');
 * / => 'N/A'
 *
 * formatNamesReplaceSpace([], '—');
 * / => '—'
 */
export const formatNamesReplaceSpace = (
    names: string[] | null | undefined,
    fallback: string = '-',
): string => {
    if (!names?.length) return fallback;
    return names.map((name) => name.replace(/ /g, NON_BREAKING_SPACE)).join(', ');
};
